import React from 'react';

import {resource} from '@albert-io/json-api-framework/request/builder';
import {useStudentDashboard} from '../StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithChildrenRequired, PropsWithClassNameOptional {
  onEnrollSuccess?: () => void;
}

export default function JoinClassroomForm({children, className, onEnrollSuccess}: Props) {
  const classrooms = useStudentDashboard((state) => state.classrooms);
  const enrollStudent = useStudentDashboard((state) => state.enrollStudent);
  const isError = useStudentDashboard((state) => state.isStudentEnrollmentError);
  const isRequestPending = useStudentDashboard((state) => state.isStudentEnrollmentPending);
  const setDuplicateClassroom = useStudentDashboard((state) => state.setDuplicateClassroom);
  const value = useStudentDashboard((state) => state.classroomCode);

  async function handleSubmit() {
    const relationship = {
      meta: {
        classroom_code: value.trim()
      },
      type: 'classroom_v1'
    };
    enrollStudent({
      relationship,
      onReject: async (err) => {
        if (err.response?.status === 422) {
          const classWithMatchingCode = classrooms.find(
            (classroom) => classroom.getCode() === value
          );

          if (classWithMatchingCode) {
            setDuplicateClassroom(classWithMatchingCode);
            return;
          }

          resource('student_classroom_v1')
            .mandarkEndpoint(['student_classrooms_v1'])
            .findOne()
            .filter({code: value})
            .getResourcePromise()
            .then((classWithMatchingCodeFromServer) => {
              setDuplicateClassroom(classWithMatchingCodeFromServer);
            });
        } else {
          throw new Error('Invalid enrollment code');
        }
      },
      onResolve: () => {
        onEnrollSuccess?.();
      }
    });
  }

  return (
    <form
      aria-label='classroom enrollment form'
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
        if (isRequestPending || isError || value === '') {
          return;
        }
        handleSubmit();
      }}
    >
      {children}
    </form>
  );
}
